import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("cafe24_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            // surfaced via auth context handler
        }
        // Normalise Pydantic 422 validation errors to a readable string so
        // toast.error(...) never tries to render an object → React crash.
        const d = err.response?.data?.detail;
        if (Array.isArray(d)) {
            err.response.data.detail = d
                .map((x) => x?.msg || (typeof x === "string" ? x : JSON.stringify(x)))
                .join(" · ");
        } else if (d && typeof d === "object") {
            err.response.data.detail = d.msg || JSON.stringify(d);
        }
        return Promise.reject(err);
    }
);

export const fmtSDG = (n, lang = "en") => {
    const v = Number(n || 0);
    const formatted = new Intl.NumberFormat(lang === "ar" ? "ar-SD" : "en-US", {
        maximumFractionDigits: 0,
    }).format(v);
    return lang === "ar" ? `${formatted} ج.س` : `SDG ${formatted}`;
};
